import React from "react";
import { createRoot } from "react-dom/client";
import SeedCatalog from "./SeedCatalog";

const rootEl = document.getElementById("root");
if (rootEl) {
  const root = createRoot(rootEl);
  root.render(<SeedCatalog />);
}